module.exports = __webpack_public_path__ + "static/img/di-zhu-jin.2224569.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/di-zhu-jin.jpeg
// module id = qPn1
// module chunks = 1